import { useLingui } from '@lingui/react';
import { consumerCarleadCreatePayloadMapper, createCarleadCreationForm, createErrorMessages } from '@wkda/carlead-creation-form';
import { DataLayerEventStack } from '@wkda/data-layer';
import { useConstant } from '@wkda/funnel-components';
import { buildPathWithQuery, getQueryParams } from '@wkda/funnel-utils';
import { deepmerge } from 'deepmerge-ts';
import { CarleadFieldsMap } from '../../carleadFieldsMap';
import { useCarleadConfiguration } from '../useCarleadCreationConfiguration';
import { useCarleadDataLayer } from '../useCarleadDataLayer';
const _defaultSteps = [['manufacturer', 'mainType', 'builtDate', 'bodyType', 'mainTypeDetail', 'mainTypeSub', 'mileage', 'email']];
export function useCreateNormalCarleadForm(params) {
  const defaults = {
    payloadMapper: consumerCarleadCreatePayloadMapper
  };
  const carleadForm = useCreateCarleadForm([defaults, ...params]);
  return carleadForm;
}
export function useCreateCarleadForm(params) {
  const configuration = useCarleadConfiguration();
  const errorMessages = useCarleadErrorMessages();
  const dataLayer = useCarleadDataLayer();
  const defaults = {
    config: configuration,
    errorMessages,
    lifecycleHooks: {
      onStepSubmitSuccess(_ref) {
        let {
          isLastStep,
          carleadHash
        } = _ref;
        new DataLayerEventStack(carleadHash).init();

        if (isLastStep) {
          const targetUrl = configuration.redirectOnSuccessUrl.replace('{hash}', carleadHash);
          const res = buildPathWithQuery(targetUrl, getQueryParams(), configuration.whitelistedQueryParams);
          window.location.href = res;
        }
      },

      onValidationError: _ref2 => {
        let {
          errors,
          values
        } = _ref2;
        Object.keys(errors).forEach(key => {
          dataLayer.pushError(CarleadFieldsMap.toDSB(key) || key, values[key] ? 'INVALID' : 'REQUIRED');
        });
      }
    }
  };
  const options = deepmerge(defaults, ...params, {
    createSteps: [function defaultSteps() {
      return _defaultSteps;
    }]
  });
  const carleadForm = createCarleadCreationForm(options);
  return carleadForm;
}

function useCarleadErrorMessages() {
  const {
    i18n
  } = useLingui();
  const messages = useConstant(() => createErrorMessages(i18n));
  return messages;
}